import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { getDocs, query, where, collection } from "firebase/firestore";
import { MdHistory, MdOutlineInventory, MdOutlineManageAccounts,MdAccountBalance, MdOutlineReceiptLong, MdOutlineWorkHistory, MdReceipt, MdSettings, MdStarBorder, MdWorkHistory } from "react-icons/md";
import { VscDashboard } from "react-icons/vsc";
import { IoIosSearch, IoMdCart, IoMdCheckmarkCircleOutline } from "react-icons/io";
import { HiOutlineDocumentReport } from "react-icons/hi";
import { PiBooks } from "react-icons/pi";
import { GrDocumentConfig } from "react-icons/gr";
import { Toast } from "../components_root/ToastContext.jsx";
import { db } from "../firebase.js";
import "./menu_popup.css";
import { MdClose, MdOutlineMenu } from "react-icons/md";
import { Add_favorites } from "./add_favorites.js";
import Aooz from '../assets/aooz_name.png';
export default function Menu_Popup({ isOpen, onClose }) {
    const panelRef = useRef(null);
    const { Toastshow } = Toast();
    const [search, setSearch] = useState(window.location.search);
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const [vouchers_masterdata, setVouchers_masterdata] = useState([]);
    const [categoryData, setCategoryData] = useState([]);
    const [brandList, setBrandList] = useState([]);
    const [categorynameTab, setCategorynameTab] = useState("accounting");
    const [activeTab, setActiveTab] = useState("home");
    // ✅ Close on ESC key
    useEffect(() => {
        const onKey = (e) => e.key === "Escape" && onClose?.();
        window.addEventListener("keydown", onKey);
        return () => window.removeEventListener("keydown", onKey);
    }, [onClose]);

    // ✅ Close when clicked outside the panel
    useEffect(() => {
        const onDocClick = (e) => {
            if (isOpen && panelRef.current && !panelRef.current.contains(e.target)) {
                onClose?.();
            }
        };
        document.addEventListener("mousedown", onDocClick);
        return () => document.removeEventListener("mousedown", onDocClick);
    }, [isOpen, onClose]);

    // ✅ Fetch Categories

    useEffect(() => {
        const params = new URLSearchParams(search);
        const tab = params.get("page");

        if (tab) {
            const t = tab.toLowerCase();
            setcategoryproductsTabInUrl(t);
            setCategorynameTab(t);
        } else {
            setCategorynameTab("/");
        }
    }, [search]);
    // 

    //brandname
    useEffect(() => {
        const params = new URLSearchParams(search);
        const tab = params.get("page");

        if (tab) {
            const t = tab.toLowerCase();
            setcategoryproductsTabInUrl(t);
            setCategorynameTab(t);
        } else {
            setCategorynameTab("accounting");
        }
    }, [search]);

    const setcategoryproductsTabInUrl = (tab) => {
        const params = new URLSearchParams(window.location.search);
        params.set("page", tab);
        const newUrl = `${window.location.pathname}?${params.toString()}`;
        window.history.replaceState({}, "", newUrl);
        onClose();
    };
    const set_favorites = async (name, docuid, url) => {
        const result = await Add_favorites({ docuid, name, url, favorites_type: "menu" });
        if (result.success) {
            //Toastshow("Successfully saved.");

            // Update local state to toggle favorite
            setVouchers_masterdata(prev =>
                prev.map(v =>
                    v.voucherid === docuid
                        ? { ...v, favorites: !v.favorites }
                        : v
                )
            );
        } else {
            Toastshow(result.error || "Failed to save");
        }
    };

    return (
        <div className={`menu-popup-body ${isOpen ? "show" : ""}`}>
            {/* Overlay */}
            <div className="menu-overlay" onClick={onClose}></div>

            {/* Left Panel */}
            <div ref={panelRef} className={`menu-panel ${isOpen ? "slide-in" : "slide-out"}`}>
                <div className="menu-header b-bottom">
                    <table  >
                        <tr>
                            <td width={25}>
                                <div onClick={onClose} className="button-menu cursor "><MdClose className="menu_icon" /></div>

                            </td>
                            <td>
                                <div className="logo-div"  >
                                    <img src={Aooz} alt="Logo" className="brand-logo" />
                                    <div className='logo-name text-off'>Accounting
                                    </div>

                                </div>
                            </td>
                        </tr>
                    </table>
                </div>
                {/* Category List */}
                <div className="menu_list_div">

                    <div className="m-top">
                        <div title="Monitor" className={`ui-items cursor p-1 ${categorynameTab === "accounting" ? "menuactivemenu activemenu" : " menunonemenu"}`}

                            onClick={() => {
                                setCategorynameTab("accounting");
                                setcategoryproductsTabInUrl("accounting");
                            }}
                        >
                            <table>
                                <tbody>
                                    <tr>
                                        <td width={50} className="items-center"><VscDashboard className="icon-img" /></td>

                                        <td className="productsmenu-pc text-h2 fcap">
                                            <>Monitor</>
                                        </td>


                                    </tr>



                                </tbody>
                            </table>
                        </div>

                        <div title="Monitor" className={`ui-items  cursor p-1 ${categorynameTab === "search" ? "menuactivemenu activemenu" : " menunonemenu"}`}
                        >
                            <table>
                                <tbody>
                                    <tr>
                                        <td onClick={() => {
                                            setCategorynameTab("search");
                                            setcategoryproductsTabInUrl("search");
                                        }} width={40} className="items-center"><IoIosSearch className="icon-img" /></td>


                                        <td onClick={() => {
                                            setCategorynameTab("search");
                                            setcategoryproductsTabInUrl("search");
                                        }} className="productsmenu-pc text-h2 fcap text-l">
                                            Search
                                        </td>
                                        <td className="m-1" width={24}><MdStarBorder onClick={() => set_favorites("search", "search", "?page=search")} className="icon" /></td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>

                        <div title="Log history" className={`ui-items cursor p-1 ${categorynameTab === "log_history" ? " menuactivemenu items-back-fill " : " menunonemenu"}`}


                        >
                            <table>
                                <tbody>
                                    <tr>
                                        <td onClick={() => {
                                            setCategorynameTab("log_history");
                                            setcategoryproductsTabInUrl("log_history");
                                        }} width={40} className="items-center"><MdOutlineWorkHistory className="icon-img" /></td>

                                        <td onClick={() => {
                                            setCategorynameTab("log_history");
                                            setcategoryproductsTabInUrl("log_history");
                                        }} className="text-h2 fcap text-l">
                                            Queue & Log
                                        </td>
                                        <td className="m-1" width={24}><MdStarBorder onClick={() => set_favorites("log history", "log_history", "?page=log_history")} className="icon" /></td>

                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <div className="items-back-fill p-11 text-h3">Setup</div>
                        <div title="Vouchers master" className={`ui-items cursor  p-1 ${categorynameTab === "vouchers_master" ? " menuactivemenu items-back-fill " : " menunonemenu"}`}

                            onClick={() => {
                                setCategorynameTab("vouchers_master");
                                setcategoryproductsTabInUrl("vouchers_master");
                            }}
                        >
                            <table>
                                <tbody>
                                    <tr>
                                        <td width={40} className="items-center"><GrDocumentConfig className="icon-img" /></td>

                                        <td className="text-h2 fcap text-l">
                                            Master
                                        </td>

                                    </tr>

                                </tbody>
                            </table>
                        </div>
                        <div title="Accounts master" className={`ui-items cursor  p-1 ${categorynameTab === "accounts_master" ? " menuactivemenu items-back-fill " : " menunonemenu"}`}

                            onClick={() => {
                                setCategorynameTab("accounts_master");
                                setcategoryproductsTabInUrl("accounts_master");
                            }}
                        >
                            <table>
                                <tbody>
                                    <tr>
                                        <td width={40} className="items-center"><MdOutlineManageAccounts className="icon-img" /></td>


                                        <td className="text-h2 fcap">
                                            Accounts
                                        </td>

                                    </tr>



                                </tbody>
                            </table>
                        </div>
                        <div title="POS Receipt" className={`ui-items cursor  p-1 ${categorynameTab === "pos_receipt_master" ? " menuactivemenu items-back-fill " : " menunonemenu"}`}

                            onClick={() => {
                                setCategorynameTab("pos_receipt_master");
                                setcategoryproductsTabInUrl("pos_receipt_master");
                            }}
                        >
                            <table>
                                <tbody>
                                    <tr>
                                        <td width={40} className="items-center"><MdOutlineReceiptLong className="icon-img" /></td>

                                        <td className="text-h2 text-l fcap">
                                            POS Receipts
                                        </td>

                                    </tr>

                                </tbody>
                            </table>
                        </div>
                   
                        <div className="items-back-fill p-11 text-h3">Accounts</div>
                        <div title="Account ledger" className={`ui-items cursor  p-1 ${categorynameTab === "account_ledger" ? " menuactivemenu items-back-fill " : " menunonemenu"}`}


                        >
                            <table>
                                <tbody>
                                    <tr>
                                        <td onClick={() => {
                                            setCategorynameTab("account_ledger");
                                            setcategoryproductsTabInUrl("account_ledger");
                                        }} width={40} className="items-center" ><PiBooks className="icon-img" /></td>


                                        <td onClick={() => {
                                            setCategorynameTab("account_ledger");
                                            setcategoryproductsTabInUrl("account_ledger");
                                        }} className="text-h2 fcap text-l">
                                            Ledger
                                        </td>
                                        <td className="m-1" width={24}><MdStarBorder onClick={() => set_favorites("Ledger", "account_ledger", "?page=account_ledger")} className="icon" /></td>
                                    </tr>


                                </tbody>
                            </table>
                        </div>


                        <div title="Stock inventory" className={`ui-items cursor  p-1 ${categorynameTab === "stock_inventory" ? " menuactivemenu items-back-fill " : " menunonemenu"}`}

                            onClick={() => {
                                setCategorynameTab("stock_inventory");
                                setcategoryproductsTabInUrl("stock_inventory");
                            }}
                        >
                            <table>
                                <tbody>
                                    <tr>
                                        <td width={40} className="items-center"><MdOutlineInventory className="icon-img" /></td>


                                        <td className="text-h2 text-l  fcap">
                                            Rent inventory
                                        </td>

                                    </tr>


                                </tbody>
                            </table>
                        </div>

                        <div title="Receipt Transaction" className={`ui-items cursor p-1 ${categorynameTab === "receipt_transaction" ? " menuactivemenu items-back-fill " : " menunonemenu"}`}


                        >
                            <table>
                                <tbody>
                                    <tr>
                                        <td width={40} onClick={() => {
                                            setCategorynameTab("receipt_transaction");
                                            setcategoryproductsTabInUrl("receipt_transaction");
                                        }} className="items-center"  ><MdHistory className="icon-img" /></td>

                                        <td onClick={() => {
                                            setCategorynameTab("receipt_transaction");
                                            setcategoryproductsTabInUrl("receipt_transaction");
                                        }} className="text-h2 text-l fcap">
                                            Receipts Transaction
                                        </td>
                                        <td className="m-1" width={24}><MdStarBorder onClick={() => set_favorites("Transaction", "receipt_transaction", "?page=receipt_transaction")} className="icon" /></td>
                                    </tr>


                                </tbody>
                            </table>
                        </div>
                        <div title="Reports" className={`ui-items cursor  p-1 ${categorynameTab === "cash_books" ? " menuactivemenu items-back-fill " : " menunonemenu"}`}


                        >
                            <table>
                                <tbody>
                                    <tr>
                                        <td
                                            onClick={() => {
                                                setCategorynameTab("cash_books");
                                                setcategoryproductsTabInUrl("cash_books");
                                            }} width={40} ><PiBooks className="icon-img" /></td>

                                        <td
                                            onClick={() => {
                                                setCategorynameTab("cash_books");
                                                setcategoryproductsTabInUrl("cash_books");
                                            }} className="text-h2 text-l fcap">
                                            <>Cash books</>
                                        </td>
                                        <td className="m-1" width={24}><MdStarBorder onClick={() => set_favorites("Cash books", "cash_books", "?page=cash_books")} className="icon" /></td>
                                    </tr>


                                </tbody>
                            </table>
                        </div>

                        <div title="Vouchers list" className={`ui-items cursor p-1 ${categorynameTab === "vouchers" ? " menuactivemenu items-back-fill " : " menunonemenu"}`}

                            onClick={() => {
                                setCategorynameTab("vouchers");
                                setcategoryproductsTabInUrl("vouchers");
                            }}
                        >
                            <table>
                                <tbody>
                                    <tr>
                                        <td width={40}><GrDocumentConfig className="icon-img" /></td>

                                        <td className=" text-h2 text-l bold fcap">
                                            <>Vouchers</>
                                        </td>

                                    </tr>


                                </tbody>
                            </table>
                        </div>
                             <div className="items-back-fill p-11 text-h3">Reporting</div>
                        <div title="Account ledger" className={`ui-items cursor  p-1 ${categorynameTab === "reporting" ? " menuactivemenu items-back-fill " : " menunonemenu"}`}


                        >
                            <table>
                                <tbody>
                                    <tr>
                                        <td onClick={() => {
                                            setCategorynameTab("pos_receipt_summary");
                                            setcategoryproductsTabInUrl("pos_receipt_summary");
                                        }} width={40} className="items-center" ><HiOutlineDocumentReport className="icon-img" /></td>


                                        <td onClick={() => {
                                            setCategorynameTab("pos_receipt_summary");
                                            setcategoryproductsTabInUrl("pos_receipt_summary");
                                        }} className="text-h2 fcap text-l">
                                            pos receipt summary
                                        </td>

                                    </tr>


                                </tbody>
                            </table>
                        </div>
                             <div title="Account ledger" className={`ui-items cursor  p-1 ${categorynameTab === "reporting" ? " menuactivemenu items-back-fill " : " menunonemenu"}`}


                        >
                            <table>
                                <tbody>
                                    <tr>
                                        <td onClick={() => {
                                            setCategorynameTab("balance_sheet");
                                            setcategoryproductsTabInUrl("balance_sheet");
                                        }} width={40} className="items-center" ><MdAccountBalance className="icon-img" /></td>


                                        <td onClick={() => {
                                            setCategorynameTab("balance_sheet");
                                            setcategoryproductsTabInUrl("balance_sheet");
                                        }} className="text-h2 fcap text-l">
                                            Balance Sheet
                                        </td>

                                    </tr>



                                </tbody>
                            </table>
                        </div>
                    

                        <div title="Settings" className={`ui-items enablemenu cursor  p-1 menunonemenu  " : " menunonemenu"}`}

                            onClick={() => navigate("/company")}
                        >
                            <table>
                                <tbody>
                                    <tr>
                                        <td width={40} ><MdSettings className="icon-img" /></td>

                                        <td className="text-h2 text-l bold fcap">
                                            Settings
                                        </td>

                                    </tr>


                                </tbody>
                            </table>
                        </div>
                    </div>

                </div>
                {/* Footer Links */}
                <div className="p-11">

                    <div
                        className="ui-items cursor b-top p-2"
                        onClick={() => {
                            navigate("/pricing");
                            onClose();
                        }}
                    >
                        <div className="text-h2 sline fcap hover-u ">Pricing</div>
                    </div>
                    <div
                        className="ui-items cursor b-top p-2"
                        onClick={() => {
                            navigate("/about");
                            onClose();
                        }}
                    >
                        <div className="text-h2 sline fcap hover-u ">About Us</div>
                    </div>

                    <div
                        className="ui-items  cursor b-top p-2"
                        onClick={() => {
                            navigate("/support");
                            onClose();
                        }}
                    >
                        <div className="text-h2 sline fcap hover-u ">Support</div>
                    </div>

                    <div
                        className="ui-items cursor b-top p-2"
                        onClick={() => {
                            navigate("/feedback");
                            onClose();
                        }}
                    >
                        <div className="text-h2 sline fcap hover-u ">feedback</div>
                    </div>
                </div>
            </div>
        </div>
    );
}
